/**
 * Minimal Cookies helper (js-cookie compatible API).
 * Used by popup, announcement bar, fixed message, and age verification.
 */
(function (window) {
  'use strict';

  if (window.Cookies) {
    return;
  }

  function getCookie(name) {
    if (!name) {
      return undefined;
    }

    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );

    return match ? decodeURIComponent(match[1]) : undefined;
  }

  function setCookie(name, value, options) {
    options = options || {};

    var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    if (typeof options.expires === 'number') {
      var date = new Date();
      date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000);
      cookie += '; expires=' + date.toUTCString();
    } else if (options.expires instanceof Date) {
      cookie += '; expires=' + options.expires.toUTCString();
    }

    cookie += '; path=' + (options.path || '/');

    if (options.domain) {
      cookie += '; domain=' + options.domain;
    }

    if (options.secure) {
      cookie += '; secure';
    }

    if (options.sameSite) {
      cookie += '; samesite=' + options.sameSite;
    }

    document.cookie = cookie;
  }

  function removeCookie(name, options) {
    options = options || {};
    options.expires = -1;
    setCookie(name, '', options);
  }

  window.Cookies = {
    get: getCookie,
    set: setCookie,
    remove: removeCookie
  };
})(window);
